import { checkElementInView } from "../__utils/checkElementInView";

const mainHeader = document.getElementById('main-header');
const blockHero = document.querySelector('.block-hero--centered-text-cards');
let previousScroll = 0;

const setHeaderHeightUnit = () => {
    if (mainHeader) {
        document.documentElement.style.setProperty(
            '--headerHeight',
            `${mainHeader.offsetHeight / 16}rem`
        );
    }

    if (blockHero) {
        document.documentElement.style.setProperty(
            '--heroHeight',
            `${blockHero.offsetHeight / 16}rem`
        );
    }
};

const headerScroll = () => {
    if (!document.body.classList.contains('mega-menu-closing')) {
        if (window.pageYOffset > previousScroll) {
            document.body.classList.add('scrolled-down');
            document.body.classList.remove('scrolled-up');
        } else {
            document.body.classList.add('scrolled-up');
            document.body.classList.remove('scrolled-down');
        }

        previousScroll = window.pageYOffset <= 0 ? 0 : window.pageYOffset;
    }
};

const inView = () => {
    document.body.classList.remove('page-scrolled', 'scrolled-down');
};

const outOfView = () => {
    document.body.classList.add('page-scrolled');
};

const header = () => {
    setHeaderHeightUnit();

    if (window.pageYOffset > 0) {
        document.body.classList.add('page-scrolled', 'scrolled-up', 'initially-scrolled-down');
                
        setTimeout(function() {
            document.body.classList.remove('initially-scrolled-down');

            checkElementInView('#top', inView, outOfView, {
                root: null,
                rootMargin: "0px 0px 0px 0px",
                threshold: [1],
            });
        }, 400);
    } else {
        checkElementInView('#top', inView, outOfView, {
            root: null,
            rootMargin: "0px 0px 0px 0px",
            threshold: [1],
        });
    }
};

export { header, setHeaderHeightUnit, headerScroll };